export const UNSUBSCRIBED_USER_INGREDIENT_LIMIT = 30;
export const UNSUBSCRIBED_USER_PAGE_LIMIT = 2;
const UNSUBSCRIBED_USER_INGREDIENT_LIMIT_PERCENTAGE = 0.25;

export function getInitials(firstName, lastName) {
  // Get the first letter of the first name
  const firstInitial = firstName?.charAt(0)?.toUpperCase();

  // Get the first letter of the last name
  const lastInitial = lastName?.charAt(0)?.toUpperCase();

  // Return the initials
  return firstInitial + lastInitial;
}

export function isExceededAccessLimit(total, pageNumber, pageSize, user) {
  // const maxPageLimit = UNSUBSCRIBED_USER_PAGE_LIMIT; // number of pages accessible to unsbscribed users
  // const maxPageSizeLimit = UNSUBSCRIBED_USER_INGREDIENT_LIMIT; // number of data unsubscribed users have access to
  // const hasReachedMaxPageLimit = page + 1 > maxPageLimit;
  // const hasReachedMaxPageSizeLimit = pageSize > maxPageSizeLimit;

  // if (
  //   isUnsubscribedUser(user) &&
  //   (hasReachedMaxPageLimit || hasReachedMaxPageSizeLimit)
  // ) {
  //   return true;
  // } else {
  //   return false;
  // }
  const sizeOfAccessibleIngredients = Math.floor(
    total * UNSUBSCRIBED_USER_INGREDIENT_LIMIT_PERCENTAGE
  );

  const sizeOfAccessiblePages = Math.floor(
    sizeOfAccessibleIngredients / pageSize
  );
  const sizeOfAccessedIngredients = pageNumber * pageSize;

  const hasReachedMaxAccess =
    sizeOfAccessedIngredients > sizeOfAccessibleIngredients;

  const sizeOfAccessibleIngredientsLeft =
    sizeOfAccessibleIngredients - sizeOfAccessedIngredients;

  // console.log({
  //   total,
  //   sizeOfAccessibleIngredients,
  //   sizeOfAccessiblePages,
  //   sizeOfAccessibleIngredientsLeft,
  // });

  if (
    isUnsubscribedUser(user) &&
    (hasReachedMaxAccess || sizeOfAccessibleIngredientsLeft === 0)
  ) {
    return true;
  } else {
    return false;
  }
}

function isUnsubscribedUser(user) {
  return user?.role === "user" && !user.subscribed;
}
